import { useDispatch } from 'react-redux';
import {
  bankApplicationFunding,
  updateBankApplicationFunding,
} from '../store/actions/funding/fundingActions';
import useApplicationUid from './useApplicationUid';
import useBankApplicationFundingData from './useBankApplicationFundingData';

const useBankApplicationFundingDispatch = () => {
  const dispatch = useDispatch();
  const { BankApplicationFunding } = useBankApplicationFundingData();
  const { ApplicationUid } = useApplicationUid();

  const bankApplicationFundingDispatch = ({ data, onSuccess, onError }) => {
    if (BankApplicationFunding) {
      dispatch(
        updateBankApplicationFunding({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        bankApplicationFunding({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { bankApplicationFundingDispatch };
};

export default useBankApplicationFundingDispatch;
